module.exports = __webpack_public_path__ + "static/img/11areaB_08.a30574d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_08.png
// module id = 1088
// module chunks = 1